module.exports = __webpack_public_path__ + "fonts/karlaregular.5a488c3d.woff2";